import Vue from 'vue'
import axios from 'axios'

// Add a response interceptor
axios.interceptors.response.use(response => {
  // Do something with response data
  return response
}, error => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.error('API Error:', error.config.url, {
      status: error.response.status,
      data: error.response.data
    })
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.error('API Error (no response):', error.config.url, String(error))
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error('API Error (request setup):', error.config.url, error.message)
  }
  return Promise.reject(error)
})

// Track JS errors inside Vue instances
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue instance Exception JS: ', info, err)
}

// Track JS errors outside Vue instances
window.onerror = (message, source, lineno, colno, error) => {
  console.error('App Exception JS: ', { message, source, lineno, colno, error })
}
